<template>
  <section class="contact-form">
    <div class="container">
      <!-- Título del formulario -->
      <h2 class="contact-form__title">Contacto</h2>
      <!-- @submit.prevent="handleSubmit"  -->
      <form novalidate data-aos="fade-up" data-aos-duration="6000" @submit.prevent="submitForm">
        <!-- Nombre completo -->
        <div class="field-group" data-aos="fade-up" data-aos-delay="6000">
          <label for="fullName">{{ texts.fullName }}</label>
          <input
            id="fullName"
            v-model="form.fullName"
            type="text"
            :class="{ 'has-error': errors.fullName }"
          />
          <small v-if="errors.fullName" class="error">
            {{ errors.fullName }}
          </small>
        </div>

        <!-- Correo -->
        <div class="field-group" ata-aos="fade-up" data-aos-delay="6000">
          <label for="email">{{ texts.email }}</label>
          <input
            id="email"
            v-model="form.email"
            type="email"
            :class="{ 'has-error': errors.email }"
          />
          <small v-if="errors.email" class="error">
            {{ errors.email }}
          </small>
        </div>

        <!-- Compañía -->
        <div class="field-group" ata-aos="fade-up" data-aos-delay="6000">
          <label for="company">{{ texts.company }}</label>
          <input
            id="company"
            v-model="form.company"
            type="text"
            :class="{ 'has-error': errors.company }"
          />
          <small v-if="errors.company" class="error">
            {{ errors.company }}
          </small>
        </div>

        <!-- Asunto -->
        <div class="field-group" ata-aos="fade-up" data-aos-delay="6000">
          <label for="subject">{{ texts.subject }}</label>
          <select
            id="subject"
            v-model="form.subject"
            :class="{ 'has-error': errors.subject }"
          >
            <option value="" disabled>–</option>
            <option v-for="opt in subjectOptions" :key="opt" :value="opt">
              {{ opt }}
            </option>
          </select>
          <small v-if="errors.subject" class="error">
            {{ errors.subject }}
          </small>
        </div>

        <!-- Mensaje -->
        <div class="field-group" ata-aos="fade-up" data-aos-delay="6000">
          <label for="message">{{ texts.message }}</label>
          <textarea
            id="message"
            v-model="form.message"
            rows="6"
            :class="{ 'has-error': errors.message }"
          ></textarea>
          <small v-if="errors.message" class="error">
            {{ errors.message }}
          </small>
        </div>

        <!-- Botón enviar -->
        <div class="section-btn-submit">
          <button type="submit" class="btn-submit" :disabled="loading">
            {{ loading ? 'Enviando...' : texts.submit }}
          </button>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import axios from 'axios';
export default {
  name: 'ContactForm',
  props: {
    selectedLang: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      form: {
        fullName: '',
        email: '',
        company: '',
        subject: '',
        message: ''
      },
      errors: {},
      loading: false,
      error: null,
      subjectOptions: [
        'Consulta general',
        'Soporte',
        'Presupuesto'
      ],
      translations: {
        es: {
          fullName: 'Nombre completo*',
          email: 'Correo*',
          company: 'Compañía*',
          subject: 'Asunto*',
          message: 'Mensaje*',
          submit: 'Enviar',
          errors: {
            required: 'Este campo es obligatorio',
            email: 'Correo inválido'
          }
        },
        en: {
          fullName: 'Full Name*',
          email: 'Email*',
          company: 'Company*',
          subject: 'Subject*',
          message: 'Message*',
          submit: 'Send',
          errors: {
            required: 'Required',
            email: 'Invalid email'
          }
        },
        de: {
          fullName: 'Vollständiger Name*',
          email: 'E-Mail*',
          company: 'Firma*',
          subject: 'Betreff*',
          message: 'Nachricht*',
          submit: 'Senden',
          errors: {
            required: 'Erforderlich',
            email: 'Ungültige E-Mail'
          }
        }
      }
    }
  },
  computed: {
    texts() {
      return this.translations[this.selectedLang] || this.translations.es
    }
  },
  methods: {
    validate() {
      this.errors = {}
      const { fullName, email, company, subject, message } = this.form
      const err = this.texts.errors

      if (!fullName) {
        this.errors.fullName = err.required
      }
      if (!email) {
        this.errors.email = err.required
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        this.errors.email = err.email
      }
      if (!company) {
        this.errors.company = err.required
      }
      if (!subject) {
        this.errors.subject = err.required
      }
      if (!message) {
        this.errors.message = err.required
      }

      return Object.keys(this.errors).length === 0
    },
    handleSubmit() {
      if (this.validate()) {
        this.$emit('submit', { ...this.form })
        // resetear formulario
        this.form = {
          fullName: '',
          email: '',
          company: '',
          subject: '',
          message: ''
        }
        this.errors = {}
      }
    },
    async submitForm() {
      const { fullName, email, company, subject, message } = this.form;

      if (!fullName || !email || !company || !subject || !message) {
        this.validate()
        this.showToast('Por favor, completa todos los campos obligatorios.', 'error');
        return;
      }else{
        this.errors = {}
      }

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        this.showToast('Por favor, ingrese un correo valido.', 'error');
        return;
      }

      const emal = {
        nombre: fullName,
        correo: email,
        mensaje: `
          Empresa: ${company}\n
          Asunto: ${subject}\n
          Mensaje:\n${message}
        `
      };

      try {
        this.loading = true;
        this.error = null;

        await axios.post('https://api.frenkel.com.mx/mail', emal, {
          headers: { 'Content-Type': 'application/json' }
        });

        this.showToast('¡Formulario enviado con éxito!', 'success');

        // Reiniciar formulario
        this.form = {
          fullName: '',
          email: '',
          company: '',
          subject: '',
          message: ''
        };
      } catch (e) {
        this.error = 'Error al enviar el formulario.';
        this.showToast(this.error, 'error');
      } finally {
        this.loading = false;
      }
    },

    showToast(message, type = 'success') {
      const bgColor = type === 'success' ? '#2c74b8' : '#dc3545';
      const toast = document.createElement('div');
      toast.textContent = message;
      toast.style.cssText = `
        position: fixed;
        bottom: 30px;
        left: 50%;
        transform: translateX(-50%);
        background: ${bgColor};
        color: white;
        padding: 12px 20px;
        border-radius: 5px;
        z-index: 9999;
        font-family: 'IBM Plex Mono', monospace;
        box-shadow: 0 4px 12px rgba(0,0,0,0.2);
        animation: fadeInOut 3.5s forwards;
      `;
      document.body.appendChild(toast);

      setTimeout(() => {
        toast.remove();
      }, 3500);
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Permanent+Marker&display=swap');

.contact-form {
  background-image: url('@/assets/images/contacto-bg.png');
  background-position: center;
  background-size: cover;
  padding: 2rem 1rem;
}
.container {
  max-width: 600px;
  margin: 0 auto;
}

/* Título en Permanent Marker */
.contact-form__title {
  font-family: 'Caveat-Bold', cursive;

  font-size: 2.5rem;
  text-align: justify;
  margin-bottom: 1.5rem;
  color: #000;
}

/* Etiquetas en monospace */
label {
  font-family: monospace;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
}
.field-group {
  margin-bottom: 1.25rem;
  display: flex;
  flex-direction: column;
}

/* Inputs, select, textarea */
input,
select,
textarea {
  border: 2px solid #000;
  padding: 0.5rem;
  font-family: inherit;
  font-size: 1rem;
  background: #fff;
}
.has-error {
  border-color: #c00;
}
.error {
  color: #c00;
  font-size: 0.85rem;
  margin-top: 0.25rem;
}

/* Botón en Permanent Marker */
.btn-submit {
  width: 100%;
  background: #000;
  color: #fff;
  font-family: 'Caveat-Bold', cursive;
  font-size: 1.5rem;
  /* text-align: justify; */
  padding: 0.75rem;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
}
.btn-submit:hover {
  background-color: #2c74b8;
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  color: #ffffff
}
.section-btn-submit{
  text-align: center !important;
}
input:focus,
select:focus,
textarea:focus {
  outline: none;
  border-color: #2c74b8;
  box-shadow: 0 0 0 4px rgba(44, 116, 184, 0.2);
  transform: scale(1.02);
  transition: all 0.25s ease;
}
@keyframes fadeInOut {
  0% { opacity: 0; transform: translateX(-50%) translateY(20px); }
  10% { opacity: 1; transform: translateX(-50%) translateY(0); }
  90% { opacity: 1; }
  100% { opacity: 0; transform: translateX(-50%) translateY(-20px); }
}
</style>
